module.exports = __webpack_public_path__ + "img/46_icon.aede06ff.png";